import { STATUS_LABELS, STATUS_TONE } from "@/lib/api";

export default function StatusBadge({ status, className = "" }) {
  const label = STATUS_LABELS[status] || status || "-";
  const tone = STATUS_TONE[status] || "neutral";
  return (
    <span data-testid={`status-badge-${status}`} className={`status-badge ${tone} ${className}`}>
      {label}
    </span>
  );
}
